import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import router from '@/routes/index.js'; 

Vue.use(VueAnalytics, {
  id: 'AW-11158645789',
  router,
  debug: {
    enabled: process.env.NODE_ENV === 'production',
    trace: false,
    sendHitTask: process.env.NODE_ENV === 'production'
  }
});